import { render, staticRenderFns } from "./IssueInvoice.vue?vue&type=template&id=3ca1b0a6&scoped=true"
import script from "./IssueInvoice.vue?vue&type=script&lang=js"
export * from "./IssueInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1b0a6",
  null
  
)

export default component.exports